import { GensetRunHoursAnalytics } from "./Types";

/**
 * Returns the last non-null timeseries point for the given scaleos_name from GensetRunHoursAnalytics data.
 * @param scaleos_name - The genset name to look up in the timeseries.
 * @param analytics - The GensetRunHoursAnalytics data object.
 * @returns The last non-null timeseries point for the given scaleos_name, or null if not found.
 */
export function getRunHours(
  scaleos_name: string,
  analytics: GensetRunHoursAnalytics,
): number | string | null {
  if (!analytics || !analytics.time_series || !Array.isArray(analytics.time_series)) {
    return null;
  }
  const lastNonNullPoint = analytics.time_series.findLast(
    (point) => point[scaleos_name] !== null && point[scaleos_name] !== undefined,
  );
  return lastNonNullPoint ? lastNonNullPoint[scaleos_name] : null;
}
